import type { AxiosInstance } from 'axios';
import type {
  FormFileUploadQueueRequest,
  FormFileUploadQueueResponse,
  FormFileUploadStartResponse,
  FormFileUploadDownloadUrlResponse,
  FormFileUploadRecord,
} from '../types/form-file-upload';

export class FormFileUploadClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  queue = (data: FormFileUploadQueueRequest): Promise<FormFileUploadQueueResponse> => {
    return this.authenticatedClient
      .post('/chat/form-file-uploads/queue', data)
      .then(res => res.data as FormFileUploadQueueResponse);
  };

  start = (id: number): Promise<FormFileUploadStartResponse> => {
    return this.authenticatedClient
      .post(`/chat/form-file-uploads/${id}/start`)
      .then(res => res.data as FormFileUploadStartResponse);
  };

  complete = (id: number): Promise<FormFileUploadRecord> => {
    return this.authenticatedClient
      .post(`/chat/form-file-uploads/${id}/complete`)
      .then(res => res.data as FormFileUploadRecord);
  };

  fail = (id: number): Promise<FormFileUploadRecord> => {
    return this.authenticatedClient
      .post(`/chat/form-file-uploads/${id}/fail`)
      .then(res => res.data as FormFileUploadRecord);
  };

  getDownloadUrl = (identifier: string): Promise<FormFileUploadDownloadUrlResponse> => {
    return this.authenticatedClient
      .get(`/chat/form-file-uploads/${encodeURIComponent(identifier)}/download-url`)
      .then(res => res.data as FormFileUploadDownloadUrlResponse);
  };
}
